/* Mublio – sluitkruis van het mobiele menu op exact dezelfde plek als de hamburger.
   De hamburger staat lager zolang de aankondigingsbalk zichtbaar is en hoger na scrollen.
   De plek wordt bijgehouden (laden, scrollen, formaat, aanraken) zolang het menu dicht is en
   als CSS-variabelen op <html> gezet; een CSS-regel plaatst het kruis. De lade opent linksboven
   in het scherm, dus de schermpositie van de hamburger = de binnenruimte van de sluitknop.
   Zo blijft het kloppen, ook als het thema het menu opnieuw opbouwt. */
(() => {
  const root = document.documentElement;

  const style = document.createElement('style');
  style.textContent = `
    #Details-menu-drawer-container .menu-drawer > .menu-drawer__close-button {
      padding-block-start: var(--mb-hamburger-y, var(--padding-lg)) !important;
      padding-inline-start: var(--mb-hamburger-x, var(--padding-lg)) !important;
    }`;
  document.head.appendChild(style);

  const meet = () => {
    const details = document.getElementById('Details-menu-drawer-container');
    if (!details || details.open || details.classList.contains('menu-open')) return;
    const icoon = details.querySelector(':scope > summary .header-drawer-icon--open svg');
    if (!icoon) return;
    const r = icoon.getBoundingClientRect();
    if (!r.width) return;
    root.style.setProperty('--mb-hamburger-y', `${Math.max(0, Math.round(r.top))}px`);
    root.style.setProperty('--mb-hamburger-x', `${Math.max(0, Math.round(r.left))}px`);
  };

  let frame = 0;
  const plan = () => {
    if (frame) return;
    frame = requestAnimationFrame(() => {
      frame = 0;
      meet();
    });
  };

  // Meten vóór de themacode het menu opent (capture), bij elke manier van openen
  ['pointerdown', 'touchstart', 'mousedown', 'click', 'keydown'].forEach((type) =>
    document.addEventListener(
      type,
      (e) => {
        if (e.target.closest && e.target.closest('#Details-menu-drawer-container > summary')) meet();
      },
      { capture: true, passive: true }
    )
  );
  window.addEventListener('scroll', plan, { passive: true });
  window.addEventListener('resize', plan);
  window.addEventListener('orientationchange', plan);
  window.addEventListener('pageshow', plan);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', meet);
  else meet();
  window.addEventListener('load', meet);
})();
